"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGracefulRequest = exports.useGracefulTheme = exports.useGraceful = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
var material_1 = require("@mui/material");
var provider_1 = require("../provider");
var react_1 = require("react");
var graceful_request_1 = require("../graceful-request");
var error_components_1 = require("../error-components");
var useGraceful = function () { return (0, react_1.useContext)(provider_1.GracefulStore); };
exports.useGraceful = useGraceful;
var useGracefulTheme = function () {
    var _a, _b, _c;
    var theme = (0, exports.useGraceful)().theme;
    var muiTheme = (0, material_1.useTheme)();
    var gracefulTheme = {
        primary: (_a = theme === null || theme === void 0 ? void 0 : theme.primary) !== null && _a !== void 0 ? _a : muiTheme.palette.primary.main,
        secondary: (_b = theme === null || theme === void 0 ? void 0 : theme.secondary) !== null && _b !== void 0 ? _b : muiTheme.palette.secondary.main,
        text: (_c = theme === null || theme === void 0 ? void 0 : theme.text) !== null && _c !== void 0 ? _c : muiTheme.palette.text.primary,
    };
    return gracefulTheme;
};
exports.useGracefulTheme = useGracefulTheme;
var useGracefulRequest = function (request) {
    var typeOfRequest = request.typeOfRequest, requestFnc = request.requestFnc, _a = request.options, _b = _a === void 0 ? __assign(__assign({ disabled: false }, graceful_request_1.defaultGracefulRequestOptions), request === null || request === void 0 ? void 0 : request.options) : _a, disabled = _b.disabled, gracefulRequestOptions = __rest(_b, ["disabled"]);
    var _c = (0, react_1.useState)({
        isError: false,
        isLoading: false,
        isRetry: false,
        data: null,
        error: null,
        errorComponent: null,
    }), state = _c[0], setState = _c[1];
    var requestRef = (0, react_1.useRef)(function () {
        return requestFnc();
    });
    var gracefulRequestOptionsRef = (0, react_1.useRef)(gracefulRequestOptions);
    var callGracefulRequest = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, graceful_request_1.gracefulRequest)(typeOfRequest, requestRef.current, function (error, res, _a) {
                            var _b;
                            var _c = _a === void 0 ? {} : _a, isLoading = _c.isLoading, isRetry = _c.isRetry;
                            var errorStatus = typeOfRequest === 'Axios'
                                ? (error === null || error === void 0 ? void 0 : error.status) ||
                                    ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status)
                                : error === null || error === void 0 ? void 0 : error.status;
                            setState({
                                isLoading: !!isLoading,
                                isRetry: !!isRetry,
                                isError: !!error,
                                data: res,
                                error: error,
                                errorComponent: errorStatus ? ((0, jsx_runtime_1.jsx)(error_components_1.GracefulErrorByStatus, { status: errorStatus })) : ((0, jsx_runtime_1.jsx)(error_components_1.WaitingRoom, { isLoading: !!isLoading })),
                            });
                        }, gracefulRequestOptionsRef.current)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setState(function (prevState) { return (__assign(__assign({}, prevState), { isError: true, error: error_1 })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [typeOfRequest]);
    (0, react_1.useEffect)(function () {
        if (disabled) {
            return;
        }
        callGracefulRequest();
    }, [callGracefulRequest, disabled]);
    return __assign(__assign({}, state), { refetch: callGracefulRequest });
};
exports.useGracefulRequest = useGracefulRequest;
